import React from 'react'
import PropTypes from 'prop-types'
import { classNames } from '@zambezi/sdk/common'
import moment from './moment'

/**
 * Create a React Month Calendar component
 *
 * @param {import('./interfaces').MonthCalendarProps} props
 * @returns {JSX.Element}
 */
function MonthCalendar ({
  isMonthDisabled,
  isMonthSelected,
  focusedMonth,
  currentMonth,
  onMonthSelected,
  idPrefix
}) {
  const MONTHS = moment.localeData().monthsShort()
  return (
    <div className={classNames('zb-month-calendar')} role='grid' aria-describedby={`${idPrefix}-month-calendar-description`}>
      <span id={`${idPrefix}-month-calendar-description`} className='zb-slider-description-sr-only'>
        You can browse through the calendar table
      </span>
      <section className='zb-month-calendar-months' role='row'>
        {MONTHS.map(renderMonth)}
      </section>
    </div>
  )

  function renderMonth (monthName, monthNumber) {
    const id = idPrefix && `${idPrefix}-${monthName}`
    const disabled = isMonthDisabled(monthNumber)
    const selected = isMonthSelected(monthNumber)
    return (
      <button
        type='button'
        role='gridcell'
        className={classNames('zb-month-calendar-month', {
          'zb-month-calendar-month-is-selected': selected,
          'zb-month-calendar-month-is-disabled': disabled,
          'zb-month-calendar-month-is-focused': focusedMonth === monthNumber,
          'zb-month-calendar-month-is-current': currentMonth === monthNumber
        })}
        onClick={onMonthClick.bind(null, monthNumber)}
        aria-selected={selected}
        disabled={disabled}
        key={monthNumber}
        id={id}
      >
        {monthName}
      </button>
    )
  }

  function onMonthClick (month) {
    if (isMonthDisabled(month)) {
      return
    }

    onMonthSelected(month)
  }
}

MonthCalendar.propTypes = {
  focusedMonth: PropTypes.number,
  currentMonth: PropTypes.number,
  isMonthSelected: PropTypes.func,
  isMonthDisabled: PropTypes.func,
  onMonthSelected: PropTypes.func,
  idPrefix: PropTypes.string
}

MonthCalendar.defaultProps = {
  isMonthSelected: d => false,
  isMonthDisabled: d => false,
  onMonthSelected: () => {}
}

export default MonthCalendar
